import { useEffect, useState } from "react";
import { apiFetch } from "../lib/api";
import { Button, Input, Table, THead, TBody, TRow, TH, TD, PageHeader, FormField, PageLayout } from "@dawa/ui";

type User = {
  id: string;
  email: string;
  credits: number;
  projects?: { contents: { id: string; primary_keyword: string }[] }[];
};

export default function Admin() {
  const [password, setPassword] = useState("");
  const [users, setUsers] = useState<User[]>([]);
  const [error, setError] = useState<string | null>(null);

  const load = async (pwd: string) => {
    try {
      const res = await apiFetch("/v1/admin/users", {
        headers: { "x-admin-password": pwd },
      });
      if (!res.ok) throw new Error(res.statusText);
      const data: User[] = await res.json();
      setUsers(data);
      localStorage.setItem("adminPwd", pwd);
      setError(null);
    } catch {
      setError("Mot de passe invalide");
      setUsers([]);
    }
  };

  useEffect(() => {
    const saved = localStorage.getItem("adminPwd");
    if (saved) load(saved);
  }, []);

  if (users.length === 0) {
    return (
      <div className="p-6 max-w-md mx-auto">
        <h1 className="text-xl mb-4">Admin</h1>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            load(password);
          }}
        >
          <FormField label="Mot de passe" htmlFor="admin-pwd" required>
            <Input
              id="admin-pwd"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mb-2"
              placeholder="Mot de passe"
              aria-label="Mot de passe administrateur"
            />
          </FormField>
          {error && <p className="text-danger mb-2">{error}</p>}
          <Button type="submit">Entrer</Button>
        </form>
      </div>
    );
  }

  return (
    <PageLayout maxWidth="full">
      <PageHeader title="Admin" subtitle="Utilisateurs" breadcrumbs={[{ label: "Admin" }, { label: "Utilisateurs" }]} />
      <Table>
        <THead>
          <TRow>
            <TH>Email</TH>
            <TH>Crédits</TH>
            <TH>Contenus</TH>
          </TRow>
        </THead>
        <TBody>
          {users.map((u) => (
            <TRow key={u.id}>
              <TD>{u.email}</TD>
              <TD>{u.credits}</TD>
              <TD>{u.projects?.flatMap((p) => p.contents).length ?? 0}</TD>
            </TRow>
          ))}
        </TBody>
      </Table>
    </PageLayout>
  );
}
